export default () => {
    const triggers = Array.from(document.querySelectorAll('[data-hook="show-related"]'));
    let allRelatedTargets = [];

    if (triggers && triggers.length) {
        triggers.forEach(trigger => {
            const relatedTargets = document.querySelectorAll(`[data-hook="${trigger.getAttribute('data-target')}"]`);
            allRelatedTargets.push.apply(allRelatedTargets, relatedTargets);

            trigger.addEventListener('click', event => {
                event.preventDefault();

                relatedTargets.forEach(relatedTarget => {
                    relatedTarget.classList.toggle('is-open');

                    if (event.currentTarget.getAttribute('data-target') === 'quick-search') {
                        const searchField = relatedTarget.querySelector('input[type="search"]');
                        if (searchField) searchField.focus();
                    }
                });
            }, false);
        });

        allRelatedTargets = allRelatedTargets.filter((value, index, self) => self.indexOf(value) === index);

        document.addEventListener('click', event => {
            allRelatedTargets.forEach(relatedTarget => {
                if (relatedTarget.classList.contains('is-open')) {
                    if (!relatedTarget.contains(event.target) 
                        && triggers.every(trigger => !trigger.contains(event.target) && trigger !== event.target)) {
                        relatedTarget.classList.toggle('is-open');
                        event.preventDefault();
                    }
                }
            });
        }, false);

        window.addEventListener('keydown', event => {
            if (event.defaultPrevented) {
                return;
            }

            switch (event.key) {
            case 'Escape':
                allRelatedTargets.forEach(relatedTarget => {
                    if (relatedTarget.classList.contains('is-open')) {
                        relatedTarget.classList.toggle('is-open');
                    }
                });
                break;
            default:
                return;
            }
            event.preventDefault();
        }, true);
    }
};
